import React, { useState, useEffect } from 'react';
import {
    Button,
    Col,
    FormGroup,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row,
} from 'reactstrap';
import Select from 'react-select';
import Swal from 'sweetalert2';
import { useDispatch } from 'react-redux';
import { fazendaAction, visitaAction } from '../_actions';

export const ModalAnimaisFazenda = ({ openModalSelectFazenda, handleCloseModalSelectFazenda, props }) => {
    const [fazendaSelecionada, setFazendaSelecionada] = useState([]);
    const dispatch = useDispatch();

    useEffect(() => {
        if (openModalSelectFazenda) {
            dispatch(fazendaAction.getFazendaSelect());
        }
    }, [openModalSelectFazenda]);

    const handleSelectChange = prop => event => {
        if (prop === 'id_fazenda') {
            setFazendaSelecionada(event ? event.map(x => x.value) : []);
        }
    };

    const renderOptionsFazenda = () => {
        return props.fazenda.fazenda.map((p, i) => {
            return (
                { value: p.id, label: p.nome }
            );
        });
    };

    const handleGeraRelatorioAnimais = () => {

        if (fazendaSelecionada && fazendaSelecionada.length > 0) {

            const { match: { params } } = props;

            var data = new Date();
            var dia = String(data.getDate()).padStart(2, '0');
            var mes = String(data.getMonth() + 1).padStart(2, '0');
            var ano = data.getFullYear();
            var dataAtual = ano + "-" + mes + "-" + dia;

            let payload = {
                id: params.id,
                id_fazenda: fazendaSelecionada[0],
                ids_fazendas: fazendaSelecionada.join(','),
                data: dataAtual,
                tipo_relatorio: "EX"
            };

            dispatch(visitaAction.createVisita(payload, true));
        } else {
            Swal.fire({
                icon: 'warning',
                title: 'Erros de valida&ccedil;&atilde;o',
                showCloseButton: true,
                showConfirmButton: true,
                html: '<div style="font-size: 14px; text-align: left">Selecione uma fazenda</div>'
            });
        }
    }


    return (
        <div>
        <Modal isOpen={openModalSelectFazenda} onClose={handleCloseModalSelectFazenda} aria-labelledby="form-dialog-title">
                <ModalHeader id="form-dialog-title">Gerar relat&oacute;rio de animais por fazenda</ModalHeader>
            <ModalBody>
                <Row>
                    <Col>
                        <FormGroup>
                            <Label className="left" for="selecionarFazenda">Selecione uma fazenda: *</Label>
                            {openModalSelectFazenda &&
                                <Select
                                    isMulti
                                    classNamePrefix="select"
                                    value={renderOptionsFazenda().filter(function (option) {
                                        return fazendaSelecionada.includes(option.value);
                                    })}
                                    onChange={handleSelectChange('id_fazenda')}
                                    isSearchable
                                    placeholder="Selecione..."
                                    id="id_fazenda"
                                    name="id_fazenda"
                                    options={renderOptionsFazenda()}
                                />
                            }
                        </FormGroup>
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter>
                <Button onClick={handleCloseModalSelectFazenda} color="secondary">Cancelar</Button>
                    <Button onClick={handleGeraRelatorioAnimais} color="primary">Gerar relat&oacute;rio</Button>
            </ModalFooter>
            </Modal>
        </div>
    )
}